import { useState, useEffect, useCallback } from "react";

const KONAMI_SEQUENCE = [
  "ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown",
  "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight",
  "b", "a",
];

export const useKonamiCode = (callback) => {
  const [index, setIndex] = useState(0);
  const stableCallback = useCallback(callback, [callback]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (key === KONAMI_SEQUENCE[index]) {
        const next = index + 1;
        if (next === KONAMI_SEQUENCE.length) {
          stableCallback();
          setIndex(0);
        } else {
          setIndex(next);
        }
      } else {
        setIndex(key === KONAMI_SEQUENCE[0] ? 1 : 0);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [index, stableCallback]);
};

export default useKonamiCode;
